module.exports = __webpack_public_path__ + "img/10_3.31bce515.png";